import React from 'react';
import "../Figure.css"


function Figure10() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
            <th> </th>
              <th> Zn concentration after incubation (30min)</th>
              <th> Zn concentration after removal of the blank </th>
              <th> Zn uptake </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> Water </th>
              <td> 1.33 mg/L </td>
              <td> 1.12 mg/L </td>
              <td> 0 mg/L </td>
            </tr> 
            <tr>
              <th> EC20 </th>
              <td> 0.44 mg/L </td>
              <td> 0.45 mg/L </td>
              <td> 0.97 mg/L </td>
            </tr>
            <tr>
              <th> SpaC </th>
              <td> 0.71 mg/L </td>
              <td> 0.45 mg/L </td>
              <td> 0.67 mg/L </td>
            </tr>
            <tr>
              <th className="colored-cell" colSpan="3"> Uptake difference </th>
              <th className="colored-cell">0.3 mg/L</th>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure10;